import { TbColumn } from '@components-library/tb-board/board.model'

export function isBoardCardData<T>(
    data: Record<string | symbol, unknown>,
): data is { boardCardData: T } {
    return !!data.boardCardData
}

export function findItemInColumns<T extends { guid: string }>(
    guid: string,
    columns: TbColumn<T>[],
) {
    return columns.find((column) => column.data.find((card) => card.guid === guid))
}

export function findInColumn<T extends { guid: string }>(column: TbColumn<T>, item: T) {
    return column.data.findIndex((columnItem) => columnItem.guid === item.guid)
}
